// Simple gallery content. Replace or extend with your own images.
import pinball from 'assets/windowsIcons/pinball.png';
import earth from 'assets/windowsIcons/earth.png';
import windows from 'assets/windowsIcons/windows.png';
import resumeIcon from 'assets/windowsIcons/resume32.png';

export const PICTURES = [
  {
    id: 'pic-pinball',
    src: pinball,
    title: 'Pinball',
    description: 'Classic Windows XP vibes.',
  },
  {
    id: 'pic-earth',
    src: earth,
    title: 'Earth',
    description: 'Status icon turned wallpaper concept.',
  },
  {
    id: 'pic-windows',
    src: windows,
    title: 'Windows',
    description: 'The old new look.',
  },
  {
    id: 'pic-resume',
    src: resumeIcon,
    title: 'Resume Icon',
    description: 'Just for fun.',
  },
];
